import { render, staticRenderFns } from "./MemberOrders.vue?vue&type=template&id=066a76a0&scoped=true"
import script from "./MemberOrders.vue?vue&type=script&lang=js"
export * from "./MemberOrders.vue?vue&type=script&lang=js"
import style0 from "./MemberOrders.vue?vue&type=style&index=0&id=066a76a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a76a0",
  null
  
)

export default component.exports